import React from 'react';

const Swap = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 14 12" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="Swap_a"
        d="M451.28 254.24h10.18v1.69c0 .08.02.14.08.2.06.05.12.08.2.08.08 0 .15-.02.2-.08l2.83-2.82a.28.28 0 0 0 .07-.2.27.27 0 0 0-.08-.2l-2.81-2.82a.33.33 0 0 0-.21-.09.27.27 0 0 0-.2.08.28.28 0 0 0-.08.2v1.7h-10.18a.27.27 0 0 0-.2.08.27.27 0 0 0-.08.2v1.7c0 .07.03.14.08.2.06.05.13.08.2.08"
      />
      <path
        id="Swap_b"
        d="M464.56 257.63H454.4v-1.7a.27.27 0 0 0-.09-.2.27.27 0 0 0-.2-.08.27.27 0 0 0-.2.08l-2.82 2.82a.28.28 0 0 0-.08.2c0 .08.03.15.08.2l2.81 2.82c.07.06.15.1.22.1s.14-.04.2-.1a.27.27 0 0 0 .08-.2v-1.68h10.17c.08 0 .14-.03.2-.09a.27.27 0 0 0 .08-.2v-1.7a.27.27 0 0 0-.08-.19.27.27 0 0 0-.2-.08"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Swap_a" transform="translate(-451 -250)" />
    <use fill="currentColor" xlinkHref="#Swap_b" transform="translate(-451 -250)" />
  </svg>
);

export default Swap;



// WEBPACK FOOTER //
// ./src/common/icons/Swap.js